type Props = {
  values: number[]
  /** Fixed ceiling for the Y axis; omit to scale to the data. */
  ceiling?: number
  /** Draws a dashed reference line, e.g. the 1.0x realtime threshold. */
  reference?: number
  color?: string
  width?: number
  height?: number
  title?: string
}

export function Sparkline({
  values,
  ceiling,
  reference,
  color = 'var(--accent)',
  width = 132,
  height = 30,
  title,
}: Props) {
  if (values.length < 2) {
    return <svg className="spark" width={width} height={height} role="img" aria-label={title ?? 'sense dades'} />
  }

  const max = Math.max(ceiling ?? 0, ...values, reference ?? 0) || 1
  const step = width / (values.length - 1)
  const y = (v: number) => height - (Math.max(0, Math.min(v, max)) / max) * (height - 2) - 1

  const line = values.map((v, i) => `${(i * step).toFixed(1)},${y(v).toFixed(1)}`).join(' ')
  const area = `0,${height} ${line} ${width},${height}`

  return (
    <svg className="spark" width={width} height={height} role="img" aria-label={title ?? 'evolució'}>
      <polygon points={area} fill={color} opacity={0.14} />
      {reference !== undefined && (
        <line x1={0} x2={width} y1={y(reference)} y2={y(reference)} stroke="var(--muted)" strokeWidth={1} strokeDasharray="3 3" opacity={0.6} />
      )}
      <polyline points={line} fill="none" stroke={color} strokeWidth={1.5} strokeLinejoin="round" strokeLinecap="round" />
    </svg>
  )
}
